import { useOktaAuth } from "@okta/okta-react";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { useAccessToken } from "./accessTokenOkta"; 

const LoginOkta = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);
  const navigate = useNavigate();

  // const { accessToken, error } = useAccessToken(); 

  useEffect(() => {
    // if (window.location.hostname === "graydi.io" && accessToken) {
    //   console.log("AccessToken válido en producción:", accessToken);
    // }

    // if (authState?.isAuthenticated) {
      navigate("/home");
    // }
  }, [authState, navigate]);

  return <div></div>;
};

export default LoginOkta;
